// extracted by mini-css-extract-plugin
export default {"webinarMainContainer":"Webinars_webinarMainContainer__vk8hB","icon":"Webinars_icon__pNcQy","preVal":"Webinars_preVal__1y7HD"};